<template>
    <div class="animated fadeIn">
        <spinner v-if="loading"/>
      <b-card>
          <div slot="header">
            <strong>Search SRF</strong>
          </div>
          <b-row>
              <b-col sm="3">
                  <b-form-group>
                      <label>SRF Num</label>
                          <b-form-input type="text" id="wto_num" v-model="filter.srf_num"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col sm="3">
                  <b-form-group>
                      <label for="country_id">Country</label>
                      <countryLookup v-bind:url="apiCountryLookup" v-on:selected="setCountry($event)" :lookupId="filter.country_id"/>
                  </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                    <label for="date_start">Date Start</label>
                        <b-form-input type="date" v-model="filter.date_start"></b-form-input>
                </b-form-group>
              </b-col>
            <b-col sm="2">
                <b-form-group>
                    <label for="date_end">Date End</label>
                        <b-form-input type="date" v-model="filter.date_end"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group>
                    <label for="status">Status</label>
                        <b-form-select id="status" v-model="filter.status"
                              :plain="true"
                              :options="['','OPEN', 'PARTIAL', 'RETURN DUE','CLOSED']"
                              value="">
                        </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <div slot="footer">
              <b-button type="submit" size="lg" variant="primary" @click="search">Search</b-button>
              &nbsp;&nbsp;
              <b-button type="submit" size="lg" variant="success" @click="newSRF">New SRF</b-button>
          </div>
      </b-card>
      <b-row v-if="getRowCount(searchResults) > 0 && !loading">
          <b-col sm="12" >
            <b-card>
                <div slot="header">
                    <strong>Search Results</strong>
                </div>
                <div class="table-responsive">
                  <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :current-page="currentPage"
                  :per-page="perPage" :items="searchResults" @row-clicked="rowClick">
                </b-table>
                </div>
              <nav>
                <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
              </nav>
              <div slot="footer">
                  <exportExcel class   = "btn btn-primary btn-lg" size ="lg" :data   = "searchResults" :fields = "exportHeaders" name = "srf.xls">
                      Export to Excel
                  </exportExcel>
                  &nbsp;
                  <b-button type="submit" size="lg" variant="success" @click="print">Print</b-button>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-else-if="noResults && !loading" >
              <b-col sm="12">
                <div align="center">
                  <strong>No SRF Found</strong>
                </div>
              </b-col>
          </b-row>
    </div>
  </template>
  <script>
  import axios from 'axios'
  import spinner from '@/components/Spinner.vue'
  import countryLookup from '@/components/Autocomplete.vue'
  import {authHeader, apiCountryLookup} from '@/functions/common.vue'
  import {apiSrfSearch} from '@/functions/common.vue'
  import exportExcel from 'vue-json-excel'
  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.fonts = {
      "ukai": {
         normal: 'ukai.ttf',
          bold: 'ukai.ttf',
          italics: 'ukai.ttf',
           bolditalics: 'ukai.ttf'
      },
   };
  export default
    {
      components:{spinner,countryLookup,exportExcel},
      props: {
        caption:
        {
          type: String,
          default: 'Table'
        },
        hover:
        {
          type: Boolean,
          default: false
        },
        striped:
        {
          type: Boolean,
          default: false
        },
        bordered:
        {
          type: Boolean,
          default: false
        },
        small:
        {
          type: Boolean,
          default: false
        },
        fixed:
        {
          type: Boolean,
          default: false
        }
      },
      data: () => {
        return {
          apiCountryLookup:apiCountryLookup,
          loading: false,
          noResults: false,
          filter:
            {
              srf_num: '',
              country_id: '',
              date_start: '',
              date_end: '',
              status:''
            },
          searchResults: [],
          searchResultsFields:
          [
              {key: 'country_id', label: 'Country'},
              {key: 'location_id' ,label: 'Location'},
              {key: 'srf_date' ,label: 'Date'},
              {key: 'srf_num' ,label: 'SRF No'},
              {key: 'requestor_user_id' ,label: 'Requestor Email'},
              {key: 'requestor_user_shortname' ,label: 'Requestor Name'},
              {key: 'reference_num' ,label: 'Reference No'},
              {key: 'reason' ,label: 'Reason'},
              {key: 'returning_type' ,label: 'Type'},
              {key: 'status' ,label: 'Returnable Status'},
              {key: 'approval_status' ,label: 'Approval Status'},
              {key: 'author_user_shortname' ,label: 'Created By'}
          ],
          currentPage: 1,
          perPage: 20,
          totalRows: 0,
          noResults: false,
          exportHeaders:
          {
            'SRF Num': 'srf_num',
            'Date': 'srf_date',
            'Country': 'country_id',
            'Location': 'location_id',
            'Requestor Email':'requestor_user_id',
            'Requestor':'requestor_user_shortname',
            'Reference #':'reference_num',
            'Reason':'reason',
            'Type':'returning_type',
            'Returnable Status':'status',
            'Approval Status':'approval_status',
            'Created By':'author_user_shortname',
          },
        }
      },
      methods:
      {
          print()
          {
                var rows = []
                var row = []
                var date = new Date()
                rows.push([
                'SRF No',
                'Date',
                'Country',
                'Location',
                'Requestor Email',
                'Requestor',
                'Reference #',
                'Reason',
                'Type',
                'Returnable Status',
                'Approval Status',
                'Created By'
                ])

                for (let key in this.searchResults)
                {
                  var data = this.searchResults[key]
                  var ref = '-'
                  if(data.reference_num != '')
                  {
                    ref = data.reference_num
                  }
                  var reason = '-'
                  if(data.reason !='')
                  {
                    reason = data.reason
                  }
                  row = [
                    data.srf_num,
                    data.srf_date,
                    data.country_id,
                    data.location_id,
                    data.requestor_user_id,
                    data.requestor_user_shortname,
                    ref,
                    reason,
                    data.returning_type,
                    data.status,
                    data.approval_status,
                    data.author_user_shortname
                ]
                  rows.push(row)
                }
                var dd = {
                  header:{ text: 'Stock Requisition Form List generated on'+ " "+ date, margin: [ 5, 10, 10, 30 ],alignment: 'center',fontSize:8 },
                  pageSize: 'A4',
                  pageOrientation: 'landscape',

                  // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                  pageMargins: [30, 30, 30, 20 ],
                  defaultStyle: {
                      font: 'ukai'
                    },
                  content: [
                    {
                      fontSize: 7.5,
                      layout: 'lightHorizontalLines', // optional
                      table:
                      {
                        // headers are automatically repeated if the table spans over multiple pages
                        // you can declare how many rows should be treated as headers
                        headerRows: 1,
                        widths: [ 'auto', 'auto', 'auto','auto', 'auto', 'auto', 'auto', '*', 'auto','auto','auto' ],
                        body:
                          rows
                      }
                    }
                  ]
                };

                pdfMake.createPdf(dd).open();
          },
        rowClick(item, index)
        {
            this.$router.push({ name: 'Stock Requisition Form Entry (SRF)', params: { srfNum: item.srf_num }})
        },
        getRowCount (items)
        {
          return items.length
        },
        search()
        {
          this.loading = true
          var sf =
          [
            "srf_num LIKE " + this.filter.srf_num
            ,"country_id = " + this.filter.country_id
            ,"srf_date >= " + this.filter.date_start
            ,"srf_date <= " + this.filter.date_end
            ,"status = " + this.filter.status
          ]
          axios.post(apiSrfSearch, sf)
            .then (res =>
            {
                return res
            })
            .then (data =>
            {
              console.log(data)
                const resultArray = []
                const myData = data.data.data.list
                for (let key in myData)
                {
                    var date = myData[key].srf_date
                    var date = new Date(date);
                    var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                    myData[key].srf_date=result
                    if(myData[key].reason =='')
                    {
                      myData[key].reason = '-'
                    }
                    resultArray.push(myData[key])
                    this.loading = false
                }
                this.searchResults = resultArray

                if(this.searchResults.length ==0)
                {
                    this.loading = false
                    this.noResults = true
                }
            })
            .catch(error => alert(error))
        },
        newSRF()
        {
          this.$router.push({ name: 'Stock Requisition Form Entry (SRF)', params: { srfNum: '_new' }})
        },
        setCountry(obj)
        {
              var id
              if (obj !== null)
              {
                id = obj.id
              }
              else
              {
                id = null
              }
              this.filter.country_id = id
        }
      },
      rowClick(item)
      {
        this.$router.push({ name: 'Stock Requisition Form Entry (SRF)', params: { sfNum: item.srf_num }})
      }
    }
  </script>



// WEBPACK FOOTER //
// src/views/srf/srfs.vue